import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BusyOverlayService } from './busy-overlay.service';
import { LaunchDarklyService } from './launchdarkly.service';

@Injectable()
export class BusyOverlayInterceptor implements HttpInterceptor {
    lds = inject(LaunchDarklyService);
    constructor(private busyOverlayService: BusyOverlayService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip Overlay all together, because it cant dequeue cancelled requests
        if (this.lds.get('disable-busy-overlay-experiment') || req.headers.has('X-SKIP-OVERLAY')) {
            return next.handle(req);
        }

        // Because HttpClient options is strongly typed, we're using headers to
        // determine if the caller wants to hide/ignore using the overlay service on this
        // call. Angular12 provides a HttpContext option to each call which should be used
        // instead once upgraded.

        const hideOverlay = req.headers.has('X-HIDEOVERLAY');
        // Register the request with the overlay service. When
        // hideOverlay is true, it is registered, but the overlay is not shown
        this.busyOverlayService.processRequest(hideOverlay);
        return next.handle(req).pipe(
            tap((evt) => {
                if (evt instanceof HttpResponse) {
                    // Dequeue
                    this.busyOverlayService.processResponse();
                }
            }),
            catchError((err) => {
                if (err instanceof HttpErrorResponse) {
                    this.busyOverlayService.processResponse();
                }
                return throwError(err);
            })
        );
    }
}
